import { LoadCounterOfferRequestData } from '.';

export interface CounterOfferData {
  allowCounterOffer: boolean;
  hasPendingCounterOffer: boolean;
  // populated when a carrier submits a request
  request: LoadCounterOfferRequestData;
  disableBookButton: boolean;
}
